require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./svgicon"), require("./truncatedtext"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./svgicon", "./truncatedtext", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./svgicon"), require("./truncatedtext"), require("./utils")) : factory(root["./svgicon"], root["./truncatedtext"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__47511__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2109],{

/***/ 13335:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports.WizardProgressIndicator = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _baUiCarbon = __webpack_require__(6536);
var _WizardProgressIndicator = _interopRequireDefault(__webpack_require__(18045));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const _CLASS = _WizardProgressIndicator.default.wizardProgressIndicatorClassName.replace(/"/g, ''); // eslint-disable-line no-underscore-dangle

const INCOMPLETE = 'INCOMPLETE';
const CURRENT = 'CURRENT';
const COMPLETED = 'COMPLETED';
const STEPS = [COMPLETED, CURRENT, INCOMPLETE];
const WizardProgressIndicator = props => {
  var _indicatorProps$curre;
  const {
    steps,
    'data-tid': dataTid = _CLASS,
    // eslint-disable-line react/prop-types
    className = '',
    // eslint-disable-line react/prop-types
    ...indicatorProps
  } = props;
  const classNames = (0, _utils.classnames)(_CLASS);
  const currentIndex = (_indicatorProps$curre = indicatorProps.currentIndex) != null ? _indicatorProps$curre : steps.findIndex(step => step.step === CURRENT);
  // extract 'step' before making use of 'stepProps'
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const mappedSteps = steps.map(_ref => {
    let {
      step,
      ...stepProps
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_baUiCarbon.ProgressStep, stepProps);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `${classNames} ${className}`,
    "data-tid": dataTid
  }, /*#__PURE__*/_react.default.createElement(_baUiCarbon.ProgressIndicator, (0, _extends2.default)({
    currentIndex: currentIndex
  }, indicatorProps), mappedSteps));
};
exports.WizardProgressIndicator = WizardProgressIndicator;
WizardProgressIndicator.propTypes = {
  /** currentIndex has the same effect as step.current (if both given they must match) */
  currentIndex: _propTypes.default.number,
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    /** step is deprecated: see the Carbon ProgressStep props */
    step: _propTypes.default.oneOf(STEPS).isRequired,
    /** current has the same effect as currentIndex (if both given they must match) */
    current: _propTypes.default.bool
  }))
};

/***/ }),

/***/ 5597:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports.WizardStepIndicator = void 0;
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _checkmarkFilled_ = _interopRequireDefault(__webpack_require__(86230));
var _current_ = _interopRequireDefault(__webpack_require__(97310));
var _incomplete_ = _interopRequireDefault(__webpack_require__(25348));
var _truncatedtext = _interopRequireDefault(__webpack_require__(47511));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _WizardStepIndicator = _interopRequireDefault(__webpack_require__(47622));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const iconMap = {
  COMPLETED: _checkmarkFilled_.default,
  CURRENT: _current_.default,
  INCOMPLETE: _incomplete_.default
};
const WizardStepIndicator = props => {
  const icon = iconMap[props.step] || iconMap.INCOMPLETE;
  const sanitizedClassName = _WizardStepIndicator.default.wizardStepIndicatorClassName.replace(/"/g, '');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: sanitizedClassName,
    "data-tid": "wizard-step-indicator"
  }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    iconId: icon.id
  }), /*#__PURE__*/_react.default.createElement(_truncatedtext.default, {
    value: props.label
  }));
};
exports.WizardStepIndicator = WizardStepIndicator;
WizardStepIndicator.propTypes = {
  label: _propTypes.default.string.isRequired,
  step: _propTypes.default.string
};

/***/ }),

/***/ 6145:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.__esModule = true;
exports.WizardStepIndicator = exports.WizardProgressIndicator = void 0;
var _WizardProgressIndicator = __webpack_require__(13335);
exports.WizardProgressIndicator = _WizardProgressIndicator.WizardProgressIndicator;
var _WizardStepIndicator = __webpack_require__(5597);
exports.WizardStepIndicator = _WizardStepIndicator.WizardStepIndicator;

/***/ }),

/***/ 74069:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"wizardProgressIndicatorClassName": "\"ba-common-WizardProgressIndicator\""
};

/***/ }),

/***/ 71935:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-wizard-step-indicator{align-items:center;display:flex;padding-right:16px;width:100%}.ba-common-wizard-step-indicator svg{fill:#1f57a4;margin-right:8px}.ba-common-wizard-step-indicator>div{display:inline}", ""]);

// exports
exports.locals = {
	"wizardStepIndicatorClassName": "\"ba-common-wizard-step-indicator\""
};

/***/ }),

/***/ 18045:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74069);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardProgressIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 47622:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71935);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_WizardStepIndicator_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 86230:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/checkmark--filled_16.js");

/***/ }),

/***/ 97310:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/current_16.js");

/***/ }),

/***/ 25348:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/incomplete_16.js");

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 47511:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__47511__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(6145));
/******/ return __webpack_exports__;
/******/ }
]);
});